import { HttpContext } from '@angular/common/http'
import { ChangeDetectorRef, Component, Inject, Optional, OnInit } from '@angular/core'
import { AbstractControl, FormBuilder, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { StartupService, I18NService } from '@core'
import { ReuseTabService } from '@delon/abc/reuse-tab'
import { ALLOW_ANONYMOUS, DA_SERVICE_TOKEN, ITokenService } from '@delon/auth'
import { _HttpClient, SettingsService, TitleService, ALAIN_I18N_TOKEN } from '@delon/theme'
import { environment } from '@env/environment'
import { NzSafeAny } from 'ng-zorro-antd/core/types'
import { finalize, interval, take } from 'rxjs'
const { msUrl } = environment.api

@Component({
  selector: 'passport-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.less'],
})
export class UserRegisterComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    @Optional()
    @Inject(ReuseTabService)
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private startupSrv: StartupService,
    private settingService: SettingsService,
    private titleSrv: TitleService,
  ) {}

  ngOnInit(): void {
    this.titleSrv.setTitle(this.i18n.fanyi('app.register.register'))
  }

  // #region fields
  form = this.fb.nonNullable.group({
    company: ['', [Validators.required]],
    nickName: ['', [Validators.required]],
    mobilePrefix: ['+86'],
    mobile: ['', [Validators.required, Validators.pattern(/^1\d{10}$/)]],
    captcha: ['', [Validators.required]],
    check: [false],
  })
  error = ''
  loading = false
  // #endregion

  count = 0
  getCaptcha(): void {
    const mobile = this.form.controls.mobile
    if (mobile.invalid) {
      mobile.markAsDirty({ onlySelf: true })
      mobile.updateValueAndValidity({ onlySelf: true })
      return
    }

    this.http
      .get(`${msUrl.auth}/captcha/key`, null, {
        context: new HttpContext().set(ALLOW_ANONYMOUS, true),
      })
      .subscribe((res) => {
        if (res.successful) {
          const { message } = res
          this.http
            .get(
              `${msUrl.auth}/captcha/phone`,
              {
                phoneNumber: mobile.value,
                captchaKey: message,
              },
              {
                context: new HttpContext().set(ALLOW_ANONYMOUS, true),
              },
            )
            .subscribe((res) => {
              if (res.successful) {
                const { data } = res
                const { expire } = data
                this.count = 60 // expire
                const numbers = interval(1000)
                const takeNumbers = numbers.pipe(take(this.count))
                takeNumbers.subscribe((x) => {
                  this.count = this.count - 1
                })
              }
            })
        }
      })
  }

  submit(): void {
    this.error = ''

    Object.keys(this.form.controls).forEach((key) => {
      const control = (this.form.controls as NzSafeAny)[key] as AbstractControl
      control.markAsDirty()
      control.updateValueAndValidity()
    })
    if (this.form.invalid) return

    const preRequest = () => {
      this.loading = true
      this.cdr.detectChanges()
    }

    const afterRequest = () => {
      this.loading = false
      this.cdr.detectChanges()
    }

    const { company, captcha, nickName, mobile } = this.form.value
    preRequest()

    const body = {
      registerType: 'phone',
      fromThird: false,
      company,
      captcha,
      nickName,
      mobile,
    }
    const options = {
      context: new HttpContext().set(ALLOW_ANONYMOUS, true),
    }
    this.http
      .post(`${msUrl.auth}/register`, body, null, options)
      .pipe(finalize(afterRequest))
      .subscribe((res) => {
        const { successful } = res
        if (!successful) {
          this.error = res.message
          this.cdr.detectChanges()
          return
        }

        sessionStorage.setItem('registerParamObj', JSON.stringify({ company, nickName, mobile }))
        const { access_token, data } = res
        this.reuseTabService.clear()
        this.tokenService.set({ token: `Bearer ${access_token}` })
        this.settingService.setUser(data)
        this.startupSrv.load().subscribe(() => {
          this.router.navigateByUrl('/')
        })
      })
  }
}
